module.exports = __webpack_public_path__ + "static/media/edit-light.ba853f0a.svg";